import { Injectable } from '@angular/core';
import {GroovePlanApiService} from "../grooveplan-api.service";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "../internals/storage.service";
import {Router} from "@angular/router";
import { SecureStorageService } from '../internals/secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserGroupeService extends GroovePlanApiService {

  constructor(_httpClient: HttpClient,
              storageService: StorageService,
              secureStorage: SecureStorageService,
              router: Router) {
    super(_httpClient, storageService, secureStorage, router);
    this.entityUrl = 'user-groupe'
  }

  sortUsersGroupesByUserIds(usersGroupes: any[]) {
    if (!Array.isArray(usersGroupes)) return {};

    const countByUser: { [userId: number]: number } = {};
    const tempByUser: { [userId: number]: any[] } = {};

    // 1️⃣ Compter les occurrences et regrouper par user_id
    for (const userGroupe of usersGroupes) {
      if (!userGroupe || userGroupe.user_id == null) continue;

      const userId = userGroupe.user_id;

      if (!tempByUser[userId]) {
        tempByUser[userId] = [];
        countByUser[userId] = 0;
      }

      tempByUser[userId].push(userGroupe);
      countByUser[userId]++;
    }

    // 2️⃣ Vérifier si au moins un utilisateur apparaît plusieurs fois
    const anyDuplicate = Object.values(countByUser).some(count => count > 1);

    // 3️⃣ Construire le résultat final
    const sortedUsersGroupes: { [userId: number]: any | any[] } = {};

    for (const userId in tempByUser) {
      sortedUsersGroupes[userId] = anyDuplicate ? tempByUser[userId] : tempByUser[userId][0];
    }

    return sortedUsersGroupes;
  }


}
